import React, { useState } from "react"
import PropTypes from "prop-types"
import { useFormik } from "formik"
import * as Yup from "yup"
import PopupModal from "components/Common/PopupModel"
import TextArea from "components/Common/TextArea"
import CButton from "components/Common/CButton"
import ConfirmButton from "components/Common/ConfirmButton"

const OfferActionModal = ({
  isOpen,
  toggle,
  title,
  offerID,
  onSubmit,
  isLoading = false,
  contextUri,
  confirmMessage = "Are you sure you want to proceed with this action?"
}) => {

  const validation = useFormik({
    initialValues: {
      comments: ""
    },
    validationSchema: Yup.object({
      comments: Yup.string()
        .required("Comments are required")
        .max(510, "Comments must be 510 characters or less")
        .trim()
    }),
    onSubmit: (values) => {
      handleSubmit(values)
    }
  })

  const handleSubmit = (values) => {
    onSubmit({
      offerID: offerID.toString(),
      comments: values.comments.trim()
    })
    
    handleClose()
  }

  const handleClose = () => {
    validation.resetForm()
    toggle()
  }

  const footerButtons = (
    <div className="d-flex gap-2">
      <CButton
        text="Cancel"
        color="secondary"
        onClick={handleClose}
        disabled={isLoading}
      />
      <ConfirmButton
        onConfirm={validation.handleSubmit}
        message={confirmMessage}
        contextUri={contextUri}
        actionType="post"
        renderButton={
          <CButton
            text="Submit"
            color="primary"
            disabled={isLoading || !validation.values.comments.trim()}
            loading={isLoading}
          />
        }
      />
    </div>
  )

  return (
    <PopupModal
      isOpen={isOpen}
      toggle={handleClose}
      title={title}
      size="md"
      footerButtons={footerButtons}
    >
      <form onSubmit={validation.handleSubmit}>
        <TextArea
          label="Comments"
          name="comments"
          placeholder="Enter your comments (required, max 510 characters)"
          validation={validation}
          required={true}
          maxLength={510}
          rows={4}
          readOnly={isLoading}
        />
      </form>
    </PopupModal>
  )
}

OfferActionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  actionType: PropTypes.string.isRequired,
  offerID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  contextUri: PropTypes.string.isRequired,
  confirmMessage: PropTypes.string
}

export default OfferActionModal